import { render, staticRenderFns } from "./CardDadosGeralFazenda.vue?vue&type=template&id=b4732cd4&lang=pug"
import script from "./CardDadosGeralFazenda.vue?vue&type=script&lang=js"
export * from "./CardDadosGeralFazenda.vue?vue&type=script&lang=js"
import style0 from "./CardDadosGeralFazenda.vue?vue&type=style&index=0&id=b4732cd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports